import React from 'react'
import PropTypes from 'prop-types'
import TrustMarkers, { TrustMarkersWithLogosGrid } from '../TrustMarkers'

const NewTrustMarkersWrapper = ({
  trustMarkersCombination,
  title,
  isDynamic,
  logosGroup,
  isFooter,
  statusCode,
  desktopTitle,
  desktopTitleClassname,
  useGridLayout = false,
}) => {
  // Choose component based on useGridLayout prop
  const TrustMarkersComponent = useGridLayout
    ? TrustMarkersWithLogosGrid
    : TrustMarkers

  return (
    <div
      className={`${logosGroup ? 'px-0' : 'px-6'} pt-8 pb-2 lg:pt-12 lg:pb-6`}
      data-testid="trust-markers-wrapper"
    >
      {title && (
        <p className="wrap-break-word text-center text-sm font-bold uppercase tracking-[.25em] text-blue-700">
          {title}
        </p>
      )}
      {desktopTitle && (
        <p
          className={`${desktopTitleClassname} wrap-break-word mx-auto w-full pb-2 text-center text-l font-bold leading-6.5 text-neutral-300`}
        >
          {desktopTitle}
        </p>
      )}
      <div className="px-4 lg:px-0">
        <TrustMarkersComponent
          trustMarkersCombination={trustMarkersCombination}
          isDynamic={isDynamic}
          isFullLink={false}
          logosGroup={logosGroup}
          isFooter={isFooter}
          statusCode={statusCode}
        />
      </div>
    </div>
  )
}

NewTrustMarkersWrapper.propTypes = {
  trustMarkersCombination: PropTypes.object,
  title: PropTypes.string,
  isDynamic: PropTypes.bool,
  logosGroup: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      img: PropTypes.string,
      url: PropTypes.string,
      widget: PropTypes.object,
      alt: PropTypes.string,
      component: PropTypes.elementType,
    })
  ),
  isFooter: PropTypes.bool,
  statusCode: PropTypes.number,
  desktopTitle: PropTypes.string,
  desktopTitleClassname: PropTypes.string,
  useGridLayout: PropTypes.bool,
}

NewTrustMarkersWrapper.defaultProps = {
  isFooter: true,
  statusCode: undefined,
  desktopTitleClassname: '',
  useGridLayout: false,
}

export default NewTrustMarkersWrapper
